// extracted by mini-css-extract-plugin
export var statItem = "_g9-1";
export var statsRow = "_g9-0";